import {
  useIsXS,
  UserTierTypes,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';

import TierBadge from './TierBadge';
import {useTheme} from 'styled-components/native';

export interface UserInfoSummaryProps {
  fullName: string;
  accountId: string;
  toggleExpand: () => void;
  isOpen: boolean;
  currentLevel?: UserTierTypes; // Optional to handle loading state before API returns data
  isGiftedTier: boolean;
}

const UserInfoSummary: React.FC<UserInfoSummaryProps> = props => {
  const {
    fullName,
    accountId,
    currentLevel,
    toggleExpand,
    isOpen,
    isGiftedTier,
  } = props;

  const theme = useTheme();
  const {shuttleGray, tuna} = theme.colors;
  const isXS = useIsXS();

  // Don't render if tier data hasn't loaded yet
  if (!currentLevel) {
    return null;
  }

  return (
    <View>
      <View
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        marginBottom="8px">
        <TierBadge tier={currentLevel} isGiftedTier={isGiftedTier} />
      </View>
      <View maxWidth={isXS ? undefined : '200px'}>
        <Text
          fontFamily="heading"
          fontWeight="bold"
          fontSize="22px"
          color={tuna}
          paddingBottom="8px"
          numberOfLines={2}>
          {fullName}
        </Text>
      </View>
      <Text
        fontFamily="body"
        fontWeight="bold"
        fontSize="9px"
        letterSpacing="1px"
        color={shuttleGray}>
        {accountId}
      </Text>
    </View>
  );
};

export default UserInfoSummary;
